export const REFRESH_BTPS = 'REFRESH_BTPS';
export const CLEAR_BTPS_FILTERS = 'CLEAR_BTPS_FILTERS';
export const FILTER_BTPS = 'FILTER_BTPS';
export const GET_BTPS = 'GET_BTPS';
